export enum SelfServeFileType {
    BillOfSale = 0,
    MSO = 1,
    EmissionComplianceLabel = 2,
    RecallClearanceLetter = 3,
    KelleyBlueBookReport = 4,
    DeathCertificate = 5,
    B3Form = 6,
}



// WEBPACK FOOTER //
// ./app/objects/documents/SelfServeFileType.ts